<template>
  <!-- phone-flush: no telefone o painel vai de borda a borda, com o respiro dele (ver InstanceCard) -->
  <ontos-base v-bind="baseProps" ref="base" phone-flush>
    <!-- O painel das páginas de formulário do app, o mesmo da edição do item: o nome do ambiente
         no título e o que se faz nele no subtítulo, a saída no cabeçalho e o Salvar no rodapé. O
         Salvar ficava ao lado dos campos, fora do padrão (relato do usuário). O "salvando" é o da
         página (`baseProps`), e por isso o painel só recebe o estado do botão. -->
    <ontos-form-panel v-if="loaded" v-bind="heading" :save-disabled="isSaving || !hasChanges" @save="save">
      <template #controls>
        <!-- De volta à aba Informações, que é de onde se chega aqui -->
        <ontos-header-action icon="mdi-arrow-left" :label="$tt('back')"
                             :to="workspaceDesignRoute(params.system, 'info')"/>
      </template>
      <v-form ref="form">
        <ontos-system-input ref="input" fixed-alias :value="system" @input="system = $event" :systems="systems"
                            @showMessage="$emit('showMessage', $event)"/>
      </v-form>
    </ontos-form-panel>
  </ontos-base>
</template>
<script lang="ts">
import {Component, toNative} from 'vue-facing-decorator'
import SystemInput from "@/components/design/system/SystemInput.vue";
import RouteComponent from "@/components/shared/RouteComponent";
import {NotUniqueError} from "@/errors/errors";
import {updatedProps} from "@/utils/modelUtils";
import {timeZoneOf} from "@/utils/timeZones";
import {workspaceEdit} from "@/utils/heading";
import FormPanel from "@/components/shared/FormPanel.vue";
import {workspaceDesignRoute} from "@/utils/breadcrumb";

type System = { title: string, alias: string, timeZone?: string, description?: string };

@Component({emits: ['updateSystem'], components: {'ontos-system-input': SystemInput, 'ontos-form-panel': FormPanel}})
class EditSystem extends  RouteComponent {
  //Exposto ao template: o Voltar leva à aba de onde se veio
  workspaceDesignRoute = workspaceDesignRoute
  system: System = {title: "", alias: ""}
  originalSystem: System = {title: "", alias: ""}
  systems: System[] = []
  declare $refs: {input: InstanceType<typeof SystemInput>}

  get systemUpdate() {
    return updatedProps(this.originalSystem, this.system)
  }

  /** Sem alteração não há o que salvar — como na edição do item. */
  get hasChanges(): boolean {
    return Object.keys(this.systemUpdate).length > 0
  }

  /** Pelo nome gravado, e não pelo que se digita: o cabeçalho diz qual ambiente se está editando. */
  get heading() {
    return workspaceEdit(this.originalSystem)
  }

  async load() {
    this.systems = await this.$systems.list()
    const found = this.systems.find(system => system.alias === this.params.system)
    if (found) {
      //O ambiente de antes do campo não tem fuso, e vale o padrão: é ele que o campo mostra. Nos
      //dois lados, para não sair numa alteração que ninguém fez
      this.system = {...found, timeZone: timeZoneOf(found)}
      this.originalSystem = {...this.system}
    }
    else this.throwError(this.$tt('error.load-workspace', {name: this.system.alias}))
  }

  async save() {
    const input = this.$refs.input;
    await this.saving(async () => {
      try {
        if (input.validateModel()) {
          const {system: systemAlias} = this.params
          await this.$systems.update({systemAlias}, this.systemUpdate)
          this.info(this.$tt('info.workspace-updated', {name: this.system.title}))
          this.$emit("updateSystem", this.system)
          await this.$router.push(workspaceDesignRoute(this.system.alias, 'info'))
        }
      } catch (err) {
        if (err instanceof NotUniqueError) {
          input.notUnique(err.data.property as 'title' | 'alias')
        } else this.throwError(this.$tt('error.update-workspace', {name: this.system.title}), err)
      }
    })
  }
}


export default toNative(EditSystem)
</script>